var map = {
	"./changing.svg": 27140,
	"./diamond_frame.svg": 20077,
	"./frame.svg": 93484,
	"./gold_frame.svg": 4557,
	"./ic_Back_48.svg": 44532,
	"./ic_Calendar_16.svg": 99756,
	"./ic_Cup_1st_80.svg": 19172,
	"./ic_Cup_2nd_80.svg": 17752,
	"./ic_Cup_3rd_80.svg": 39843,
	"./ic_Diary_20.svg": 99710,
	"./ic_Help_20.svg": 94638,
	"./ic_Info_20.svg": 29557,
	"./ic_LogOut_20.svg": 20583,
	"./ic_Material.svg": 55631,
	"./ic_Next_48.svg": 51502,
	"./ic_Password_20.svg": 51284,
	"./ic_Photo_36.svg": 36212,
	"./ic_Registration.svg": 14551,
	"./ic_Repair.svg": 8627,
	"./ic_School_20.svg": 86757,
	"./ic_Setting_24.svg": 92385,
	"./ic_Sync_20.svg": 71758,
	"./ic_User_20.svg": 70318,
	"./ic_classroom.svg": 3149,
	"./icon_info.svg": 82317,
	"./icon_logout.svg": 45143,
	"./icon_password.svg": 81206,
	"./icon_security.svg": 74967,
	"./photo-camera.svg": 29041,
	"./silver_frame.svg": 3336,
	"./special_frame.svg": 69440,
	"./star.svg": 58441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83295;